import {
  INIT_CHAT_REQUESTED,
  INIT_CHAT_SUCCEEDED,
  INIT_CHAT_FAILED,
  SET_CONVERSATIONS_LIST,
  UPDATE_CONVERSATION,
  INSERT_CONVERSATION,
  REMOVE_CONVERSATION,
  INSERT_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_REQUESTED,
  SEND_CHAT_MESSAGE_SUCCEEDED,
  SEND_CHAT_MESSAGE_FAILED,
  END_CONVERSATION_REQUESTED,
  END_CONVERSATION_SUCCEEDED,
  END_CONVERSATION_FAILED,
  OPEN_FORWARD_DIALOG,
  FORWARD_CONVERSATION_REQUESTED,
  FORWARD_CONVERSATION_SUCCEEDED,
  FORWARD_CONVERSATION_FAILED,
  CLOSE_FORWARD_DIALOG,
  SELECT_CONVERSATION_REQUESTED,
  SELECT_CONVERSATION_SUCCEEDED,
  SELECT_CONVERSATION_FAILED,
  DESTROY_CHAT,
  UPDATE_SELECTED_CONVERSATION,
  LOAD_OLDER_MESSAGES_REQUESTED,
  LOAD_OLDER_MESSAGES_SUCCEEDED,
  LOAD_OLDER_MESSAGES_FAILED,
  CLEAR_SELECTED_CONVERSATION,
  END_CONVERSATION_FOR_OPERATOR_REQUESTED,
  DELETE_CHAT_MESSAGE,
  EDIT_CHAT_MESSAGE,
  HANDLE_NOT_SENT_MESSAGE,
  USER_TYPING_START, USER_TYPING_STOP
} from './actionTypes';


export function userTypingStart(conversationId) {
  return {
    type: USER_TYPING_START,
    payload: {
      conversationId,
    },
  };
}

export function userTypingStop(conversationId) {
  return {
    type: USER_TYPING_STOP,
    payload: {
      conversationId,
    },
  };
}

export function initChatRequested() {
  return {
    type: INIT_CHAT_REQUESTED,
  };
}

export function initChatSucceeded() {
  return {
    type: INIT_CHAT_SUCCEEDED,
  };
}

export function initChatFailed() {
  return {
    type: INIT_CHAT_FAILED,
  };
}

export function setConversationsList(conversationsList) {
  return {
    type: SET_CONVERSATIONS_LIST,
    payload: {
      conversationsList,
    },
  };
}

export function updateConversation(id, update) {
  return {
    type: UPDATE_CONVERSATION,
    payload: {
      id,
      update,
    },
  };
}

export function insertConversation(conversation) {
  return {
    type: INSERT_CONVERSATION,
    payload: {
      conversation,
    },
  };
}

export function removeConversation(id) {
  return {
    type: REMOVE_CONVERSATION,
    payload: {
      id,
    },
  };
}


export function selectConversationRequested(conversation) {
  return {
    type: SELECT_CONVERSATION_REQUESTED,
    payload: {
      conversation,
    },
  };
}

export function selectConversationSucceeded(conversation, messages, messagesTotalNumber) {
  return {
    type: SELECT_CONVERSATION_SUCCEEDED,
    payload: {
      conversation,
      messages,
      messagesTotalNumber,
    },
  };
}

export function selectConversationFailed() {
  return {
    type: SELECT_CONVERSATION_FAILED,
    payload: {},
  };
}


export function insertChatMessage(message) {
  return {
    type: INSERT_CHAT_MESSAGE,
    payload: {
      message,
    },
  };
}

export function deleteChatMessage(message) {
  return {
    type: DELETE_CHAT_MESSAGE,
    payload: {
      message,
    },
  };
}

export function editChatMessage(message) {
  return {
    type: EDIT_CHAT_MESSAGE,
    payload: {
      message,
    },
  };
}

export function handleNotSentMessage(message) {
  return {
    type: HANDLE_NOT_SENT_MESSAGE,
    payload: {
      message,
    },
  };
}

export function sendChatMessageRequested(message, commentMessage) {
  return {
    type: SEND_CHAT_MESSAGE_REQUESTED,
    payload: {
      message,
      commentMessage
    },
  };
}

export function sendChatMessageSucceeded() {
  return {
    type: SEND_CHAT_MESSAGE_SUCCEEDED,
  };
}

export function sendChatMessageFailed() {
  return {
    type: SEND_CHAT_MESSAGE_FAILED,
  };
}

export function endConversationRequested() {
  return {
    type: END_CONVERSATION_REQUESTED,
  };
}

export function endConversationForOperatorRequested(silentMod, conv) {
  return {
    type: END_CONVERSATION_FOR_OPERATOR_REQUESTED,
    silentMod: silentMod,
    conv: conv
  };
}

export function endConversationSucceeded(contact) {
  return {
    type: END_CONVERSATION_SUCCEEDED,
    payload: {
      contact,
    },
  };
}

export function endConversationFailed() {
  return {
    type: END_CONVERSATION_FAILED,
  };
}

export function openForwardDialog() {
  return {
    type: OPEN_FORWARD_DIALOG,
  };
}

export function closeForwardDialog() {
  return {
    type: CLOSE_FORWARD_DIALOG,
  };
}

export function forwardConversationRequested(operatorContact, silentMod, conv) {
  return {
    type: FORWARD_CONVERSATION_REQUESTED,
    silentMod: silentMod,
    conv: conv,
    payload: {
      operatorContact,
    },
  };
}

export function forwardConversationSucceeded() {
  return {
    type: FORWARD_CONVERSATION_SUCCEEDED,
  };
}

export function forwardConversationFailed() {
  return {
    type: FORWARD_CONVERSATION_FAILED,
  };
}

export function updateSelectedConversation(updateData) {
  return {
    type: UPDATE_SELECTED_CONVERSATION,
    payload: updateData,
  };
}

export function loadOlderMessagesRequested() {
  return {
    type: LOAD_OLDER_MESSAGES_REQUESTED,
    payload: {},
  };
}

export function loadOlderMessagesSucceeded(messages) {
  return {
    type: LOAD_OLDER_MESSAGES_SUCCEEDED,
    payload: {
      messages,
    },
  };
}

export function loadOlderMessagesFailed() {
  return {
    type: LOAD_OLDER_MESSAGES_FAILED,
    payload: {},
  };
}

export function clearSelectedConversation() {
  return {
    type: CLEAR_SELECTED_CONVERSATION,
  };
}

export function destroyChat() {
  return {
    type: DESTROY_CHAT,
  };
}



// WEBPACK FOOTER //
// ./src/services/chat/action.js